import { DSDatepicker, DSText } from '@vr/ds-react'
import { Controller } from 'react-hook-form'

import { ReleaseDateProps } from './type'

export const ReleaseDate = ({ methods, accountKey }: ReleaseDateProps) => {
  return (
    <>
      <Controller
        key={accountKey}
        name='dataLiberacao'
        control={methods.control}
        rules={{
          required: 'Data de liberação é obrigatório'
        }}
        render={({ field: { onChange, value } }) => (
          <DSDatepicker
            label='Data de liberação*'
            minDate={new Date(Date.now() - 1 * 24 * 60 * 60 * 1000)}
            name='dataLiberacao'
            onChange={date => {
              onChange(date?.value ?? null)
            }}
            value={value}
          />
        )}
      />
      {typeof methods.formState.errors.dataLiberacao?.message === 'string' && (
        <DSText as='span' size='sm' weight='semibold' color='errorLight'>
          {methods.formState.errors.dataLiberacao.message}
        </DSText>
      )}
    </>
  )
}
